import React from 'react';
import Styled from 'styled-components';
import Input2 from '@components/form/Input2';
import Icon from '@components/Icon';

const Wrapper = Styled.div`
  position: relative;
  width: 100%;
  border-bottom: 1px solid #D8D8D8;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const SearchIcon = Styled(Icon)`
  position: absolute;
  top: calc(50% - 8px);
  height: 20px;
`;

const Input = Styled(Input2)`
  color: #242424;
  line-height: 1;
  border: none;
  padding: 14px 24px 14px 30px;

  input:focus {
    background: none;
  }
  
  ::placeholder {
    color: #242424;
  }
`;

const Search = ({ handleChange, placeholder, value = '' }) => {
  return (
    <Wrapper>
      <SearchIcon name="ygb-icon-searchb" fontSize="18px" color="#000" />
      <Input
        name="search"
        placeholder={placeholder}
        onChange={e => handleChange(e.target.value)}
        value={value}
      />
    </Wrapper>
  );
};

export default Search;
